import React from 'react';
import { IconsPros } from './types';

/**
 * SendBackward Icon component
 *
 * @returns JSX.ELEMENT
 */
export const SendBackwardIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M2.24,11.38h8.53c.68,0,.8-.09.8-.61V1.86c0-.52-.11-.61-.8-.61H2.24c-.68,0-.8.09-.8.61v8.91C1.44,11.29,1.56,11.38,2.24,11.38Zm10.58-8h1.41c1,0,1.58.33,1.58,1.37v9.88c0,1.05-.53,1.37-1.58,1.37H4.76c-1,0-1.58-.33-1.58-1.37v-2H2.24c-1.32,0-2-.58-2-1.85V1.86C.19.58.92,0,2.24,0h8.53c1.32,0,2,.58,2,1.86Z" />
    </svg>
  );
};
